import { render, staticRenderFns } from "./AdditionsHandler.vue?vue&type=template&id=1c215b7e&scoped=true&"
import script from "./AdditionsHandler.vue?vue&type=script&lang=js&"
export * from "./AdditionsHandler.vue?vue&type=script&lang=js&"
import style0 from "./AdditionsHandler.vue?vue&type=style&index=0&id=1c215b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c215b7e",
  null
  
)

export default component.exports